import { render, staticRenderFns } from "./resetPassForm.vue?vue&type=template&id=1b7255de&scoped=true&"
import script from "./resetPassForm.vue?vue&type=script&lang=js&"
export * from "./resetPassForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7255de",
  null
  
)

export default component.exports